import * as React from "react";
import { ChevronDoubleLeft16Regular, PersonQuestionMark16Regular } from "@fluentui/react-icons";
import { IArtist } from "../../types/IArtist";
import { addArtistToProduct, updateRelatedWork, updateWorkSourceIP, addIPToAdjustmentDetails, addWorkToLicenseRequest, addIPToUsageDetails, updateProductSourceIP, addWorkToClaimRequest, updateAgreementSourceIP, addArtistToUsage, addMatchProductToUsage } from "../../../redux/reducers/RepertoireReducer";
import TableHeaderSection from "../tableHeaderSection/TableHeaderSection";
import { CopyTableContents } from "../../services/TableFunctions";
import IRepertoireComponentDataItem from "../../../redux/types/IRepertoireComponentDataItem";
import { IRepertoireField } from "../../types/IRepertoireField";
import ActionButton from "../actionButton/ActionButton";
import PaginationView from "../paginationView/PaginationView";
import {
    ADD_NEW_ACTION,
    UPDATE_ACTION,
    SEARCH_VIEW_CONTRIBUTORS,
    SEARCH_VIEW_ARTISTS,
    SEARCH_VIEW_AGREEMENT_IP,
    OPEN_ACTION,
    VERSION_HISTORY_VIEW,
    SEARCH_VIEW_WORKS,
    SEARCH_VIEW_PRODUCTS,
    IPI_NUMBER_STATE_KEY,
    ASSING_WORKFLOW_VIEW,
    EMPTY_STRING_VALUE,
    DISTRIBUTION_VERSION_HISTORY_VIEW,
    SEARCH_VIEW_LICENSE_USER,
    SEARCH_VIEW_WORK_LICENSES,
    SEARCH_VIEW_LICENSES,
    SEARCH_VIEW_LICENSES_FILEIMPORT,
    SEARCH_VIEW_WORK_CLAIMS,
    SEARCH_VIEW_CLAIMS,
    SEARCH_VIEW_SUBJECTS,
    SEARCH_VIEW_IPS,
    SEARCH_VIEW_AGREEMENT_SOURCE_IP,
    SEARCH_VIEW_LICENSE_VENUES,
    LICENSE_VENUES_KEY,
    SEARCH_VIEW_VENUES,
    ADD_TO_PACKAGE_ACTION,
    ADD_ALL_TO_PACKAGE_PROMPT_STATE_KEY,
    ADD_ALL_TO_PACKAGE_HEADER_STATE_KEY,
    PAGINATION,
    REPERTOIRE,
    IPI_NON_SELECTABLE_STATUS_CODES,
    MERGED_FROM_REPERTOIRE_WORK
} from "../../Consts";
import { hideModal } from "../../../redux/reducers/ModalReducer";
import { IP } from "../../types/IP";
import { IContributorItem } from "../../types/IContributorItem";
import { IWorksSearchResult } from "../../types/IWorksSearchResult";
import { RepertoireHelper } from "../../services/RepertoireHelper";
import { WORK_NAME_LOOKUP } from "../../../lookup/Consts";
import { getLookupValues } from "../../../lookup/services/LookupHelpers";
import { ILookupDictionary } from "../../../lookup/types/ILookupDictionary";
import { IStoragePathItemData } from '../../../dataingestion/types/IStoragePathItemData';
import { ILicenseUserSearchResult } from "../../types/ILicenseUserSearchResult";
import { IProductSearchResult } from "../../types/IProductSearchResult";
import { DRAFT_AGREEMENTS_APPLICABLE_WORKS_STATE_KEY, SEARCH_VIEW_REQUEST_ACCESS, SET_LISTS_WORK_SEARCHVIEW_STATE_KEY, SET_LIST_MODAL_SEARCH_VIEW } from "../../../membersportal/Consts";
import { IShoppingCartSearchResult } from "../../types/IShoppingCartSearchResult";
import { IDraftWorkSearchResult } from "../../../membersportal/types/IDraftWorkSearchResult";
import { IDraftSetListSearchResult } from "../../../membersportal/types/IDraftSetListSearchResult";
import { IWorkMaintenanceSubject } from "../../types/IWorkMaintenanceSubjects";
import { ISubject } from "../../types/ISubject";
import DateDataInput from "../dateDataInput/DateDataInput";
import DateDisplay from "../dateDisplay/DateDisplay";
import { IAgreementStateKeys } from "../../../redux/types/IAgreementState";
import { ICwrgParameters } from "../../../redux/types/ICwrgParameters";
import { updateDraftAgreementWorkField } from "../../../redux/reducers/MembersPortalReducer";
import { InputNumber } from "antd";
import { SizedCheckboxDataInput } from "../../components/checkboxDataInput/CheckboxDataInput";
import { ICustomerVenue } from "../../types/ISetListVenue";
import { RIGHT_ARROW_SVG } from "../../IconConsts";
import {ILicenseCustomerVenue} from "../../types/ILicenseCustomerVenue";

export interface ISearchResultsTableProps {
    searchResultsTableData: IRepertoireComponentDataItem;
    tableContents: any;
    componentInstance: string;
    addArtistToWork?: (artist: IArtist, id: number) => void;
    addArtistToProduct?: typeof addArtistToProduct;
    addWorkToProduct?: (work: IWorksSearchResult) => void;
    updateWorkContributorIP?: (workContributor: IContributorItem, ip: IP) => void;
    updateProductContributorIP?: (productContributorID: number, ip: IP) => void;
    updateAgreementIP?: (agreementAdminIPID: number, ip: IP) => void;
    updateAgreementSourceIP?:(sourceIPID:number,ip:IP)=>void;
    updateManualJobParams?: (params: any) => void;
    manualJobParameters?: any;
    updateAgreementWork?: (work: IWorksSearchResult) => void;
    updateAgreementCarveOutProduct?: (agreementProductWorkID: number, product: IProductSearchResult) => void;
    updateMatchingWork?: (workID: number, work: IWorksSearchResult) => void;
    updateMatchingProduct?: (productID: number, product: IProductSearchResult) => void;
    updateSubjects?: (subject: ISubject) => void;
    updateRelatedWork?: typeof updateRelatedWork;
    updateWorkSourceIP?: typeof updateWorkSourceIP;
    updateProductSourceIP?: typeof updateProductSourceIP;
    openHistoryVersion?: (entityId: number, versionNumber: number, mergedWork: boolean, isOpenedInSecondPane?: boolean) => void;
    sourceItem?: any;
    hideModal: typeof hideModal;
    expandedResults?: number[];
    expandAll?: boolean;
    expandResult?: (result: number) => void;
    expandAllResults?: () => void;
    onAssingWorkflows?: (username: string) => void;
    indexOfFirstResult?: number;
    indexOfLastResult?: number;
    resultsPerPage?: number;
    currentPage?: number;
    updatePagination: (indexOfFirstResult: number, indexOfLastResult: number, resultsPerPage: number, currentPage: number, repertoireSection: string) => void;
    repertoireSection?: string;
    sortSearchResults?: (name: string, results: any) => void;
    updateStoragePathItemIP?: (storagePathItemData: IStoragePathItemData, ip: IP) => void;
    addIpToAdjustmentDetail?: typeof addIPToAdjustmentDetails;
    addIPToUsageDetails?: typeof addIPToUsageDetails;
    licenseUserSearchResults?: ILicenseUserSearchResult[];
    updateLicenceUserValues?: (params: any) => void;
    addWorkToLicenseRequest?: typeof addWorkToLicenseRequest;
    requestViewAsAccess?: (requestIP: IContributorItem) => void;
    updateLicenseImportShoppingCart?: (storagePathItemData: IStoragePathItemData, shoppingCart: IShoppingCartSearchResult) => void;
    addSetListToLivePerformance?: (setList: IDraftSetListSearchResult) => void;
    addWorkToSetList?: (work: IDraftWorkSearchResult) => void;
    getProductDetails?: (dataSource: string, workID: number, openNewTab?: boolean) => void;
    addWorkToClaimRequest?: typeof addWorkToClaimRequest;
    modalIndex?: number;
    updateDraftAgreementField?: (value: any, fieldName: IAgreementStateKeys, index?: number) => void;
    updateDraftAgreementWorkField?:(value: any, fieldName: IAgreementStateKeys, index?: number)=>void;
    index?: number;
    totalWorkflows?: number;
    updateUsers?: (username: string, value: any, fieldName: string) => void;
    addVenueToUsage?: (venue: ICustomerVenue) => void;
    addLicenseVenueToUsage?: (licensVenue: ILicenseCustomerVenue) => void;
    openInSplitScreen?: (item: any, event?: React.MouseEvent) => void;
    updateCMUContributors?: (contributors: any[], modalIndex?: number) => void;
    addMatchProductToUsage?: typeof addMatchProductToUsage,
    lookupValues?: ILookupDictionary;
    ctrlPressed?: boolean;
    onSelectBulkAdjustmentIP?: (ip: IP) => void;
}

interface ISearchResultsTableState {
    tableContents: any;
    activeSortHeaderSection: string;
    currentPage: number;
    resultsPerPage: number;
    indexOfFirstResult: number;
    indexOfLastResult: number;
    isFieldEnabled: any;
    ctrlPressed?: boolean;
}

export default class SearchResultsTable extends React.PureComponent<
    ISearchResultsTableProps,
    ISearchResultsTableState
> {
    constructor(props: ISearchResultsTableProps) {
        super(props);

        this.state = {
            tableContents: props.tableContents,
            activeSortHeaderSection: undefined,
            indexOfFirstResult: this.props.indexOfFirstResult ? this.props.indexOfFirstResult : 0,
            indexOfLastResult: this.props.indexOfLastResult ? this.props.indexOfLastResult : 10,
            resultsPerPage: this.props.resultsPerPage ? this.props.resultsPerPage : 10,
            currentPage: this.props.currentPage ? this.props.currentPage : 1,
            isFieldEnabled: {},
        };
    }    

    public ascending: boolean = false;

    componentDidUpdate = (prevProps: ISearchResultsTableProps) => {
        const { tableContents } = this.props;

        if (prevProps.tableContents !== tableContents) {
            this.setState({ tableContents });
            this.setState({ indexOfFirstResult: this.props.indexOfFirstResult})
            this.setState({ indexOfLastResult: this.props.indexOfLastResult})
            this.setState({ currentPage: this.props.currentPage })
            this.setState({ resultsPerPage: this.props.resultsPerPage })
        }
    };

    sortTableByColumn = (section: string) => {
        const { componentInstance, sortSearchResults } = this.props;
        const { activeSortHeaderSection, tableContents } = this.state;
        const tableContentsCopy = CopyTableContents(tableContents);

        if (componentInstance === VERSION_HISTORY_VIEW)
            return;

        if (activeSortHeaderSection !== section) {
            this.ascending = false;
        }

        const extractValue = (x: any) => (x?.value ?? x ?? "").toString();

        tableContentsCopy.sort((a: any, b: any) => {
            const newA = extractValue(a[section]);
            const newB = extractValue(b[section]);

            if (this.ascending) {
                return newA.localeCompare(newB, undefined, { numeric: true });
            }

            return newB.localeCompare(newA, undefined, { numeric: true });
        });

        this.setState({
            tableContents: tableContentsCopy,
            activeSortHeaderSection: section
        });

        this.ascending = !this.ascending;

        if (sortSearchResults) {
            sortSearchResults(componentInstance, tableContentsCopy);
        }
    };

    onClickAdd = (tableContentItem: any) => {
    const { addArtistToWork, addArtistToProduct, addVenueToUsage, addLicenseVenueToUsage, hideModal, sourceItem, modalIndex, componentInstance } = this.props;
        if (addVenueToUsage) {
            addVenueToUsage(tableContentItem);
            hideModal();
        } else if (addArtistToWork) {
            addArtistToWork(tableContentItem, sourceItem != null ? sourceItem.workPerformerID : -1);
            hideModal();
        }
        else if(addLicenseVenueToUsage){
            addLicenseVenueToUsage(tableContentItem);
            hideModal();
        }
        else {
            addArtistToProduct(tableContentItem, sourceItem ? sourceItem.productPerformerID : -1, modalIndex);
            hideModal();
        }
    };

    enableField = (index : number, username : string) => {
        const { updateUsers } = this.props;
        this.setState((prevState) => {
            const updatedFieldState = {
                ...prevState.isFieldEnabled,
                [username]: !prevState.isFieldEnabled[username], 
            };
            updateUsers(username, updatedFieldState[username], "assigned"); 
            return {isFieldEnabled: updatedFieldState};
        }, () => {
            if (!this.state.isFieldEnabled[username]) {
                this.changeData(username, "numberOfWorkflows", null); 
            }
        });
    };

    changeData = (username: string, fieldName: string, newValue: string) => {
        const { updateUsers } = this.props;
        const { tableContents } = this.state;
        const updatedTableContents = tableContents.map(item =>
            item.userName.value === username ? { ...item, [fieldName]: { value: newValue } } : item
        );
        updateUsers(username, newValue, fieldName);
        this.setState({ tableContents: updatedTableContents });
    };

    onClickUpdate = (tableContentItem: any, index?: any) => {
        const { sourceItem,
            componentInstance,
            updateWorkContributorIP,
            updateAgreementIP,
            updateAgreementSourceIP,
            updateAgreementWork,
            updateAgreementCarveOutProduct,
            updateMatchingWork,
            updateMatchingProduct,
            updateProductContributorIP,
            addWorkToProduct,
            hideModal,
            updateRelatedWork,
            updateWorkSourceIP,
            updateProductSourceIP,
            onAssingWorkflows,
            updateStoragePathItemIP,
            addIpToAdjustmentDetail,
            addIPToUsageDetails,
            updateManualJobParams,
            manualJobParameters,
            licenseUserSearchResults,
            updateLicenceUserValues,
            addWorkToLicenseRequest,
            requestViewAsAccess,
            updateLicenseImportShoppingCart,
            addSetListToLivePerformance,
            addWorkToSetList,
            addWorkToClaimRequest,
            updateSubjects,
            getProductDetails,
            updateDraftAgreementField,
            updateDraftAgreementWorkField,
            updateCMUContributors,
            modalIndex,
            addMatchProductToUsage,
            onSelectBulkAdjustmentIP
        } = this.props;
        if (onSelectBulkAdjustmentIP) {
            onSelectBulkAdjustmentIP(tableContentItem as IP);
            hideModal();
            return;
        }
        if (updateWorkContributorIP) {
            updateWorkContributorIP(sourceItem, { ...tableContentItem });
            hideModal();
        }
        else if (addIpToAdjustmentDetail) {
            addIpToAdjustmentDetail(tableContentItem, sourceItem.adjustmentDetails.adjustmentDetailFrom[0].allocationHeaderID, sourceItem.index);
            hideModal();
        }
        else if (addIPToUsageDetails) {
            addIPToUsageDetails(tableContentItem, sourceItem.usageDetailsIndex, sourceItem.usageRowIndex, sourceItem.adjustmentsIndex);
            hideModal();
        }
        else if (componentInstance === SEARCH_VIEW_AGREEMENT_IP  ) {
            if (sourceItem.agreementAdminIPID !== undefined) {
                updateAgreementIP(sourceItem.agreementAdminIPID, { ...tableContentItem });
            }
            else {
                updateAgreementIP(-99999, { ...tableContentItem });
            }
            hideModal();
        }
        else if (componentInstance === SEARCH_VIEW_AGREEMENT_SOURCE_IP  ) {
            updateAgreementSourceIP(sourceItem.agreementSourceIP.sourceIPID, { ...tableContentItem });
            hideModal();
        }
        else if (componentInstance === DRAFT_AGREEMENTS_APPLICABLE_WORKS_STATE_KEY) {
            updateDraftAgreementWorkField(tableContentItem,'agreementWorks',modalIndex)
            hideModal();
        }
        else if(updateDraftAgreementField){
            updateDraftAgreementField(tableContentItem,'ipName')
            hideModal();
        }
        else if (componentInstance == SEARCH_VIEW_WORK_LICENSES && addWorkToLicenseRequest) {
            addWorkToLicenseRequest({ ...tableContentItem });
            hideModal();
        }
        else if (addWorkToProduct) {
            addWorkToProduct(tableContentItem);
            hideModal();
        }
        else if (updateMatchingWork) {
            updateMatchingWork(sourceItem.workID, { ...tableContentItem });
            hideModal();
        }
        else if (updateMatchingProduct) {
            updateMatchingProduct(sourceItem.productID, { ...tableContentItem });
            hideModal();
        }
        else if (updateProductContributorIP) {
            updateProductContributorIP(sourceItem.productContributorID, { ...tableContentItem });
            hideModal();
        }
        else if (updateRelatedWork) {
            updateRelatedWork({ ...tableContentItem });
            hideModal();
        }
        else if (updateWorkSourceIP) {
            updateWorkSourceIP({ ...tableContentItem });
            hideModal();
        }
        else if (updateProductSourceIP) {
            updateProductSourceIP({ ...tableContentItem });
            hideModal();
        }
        else if (componentInstance === ASSING_WORKFLOW_VIEW && onAssingWorkflows) {
            this.enableField(index, tableContentItem.userName.value)
        }
        else if (updateStoragePathItemIP) {
            updateStoragePathItemIP(sourceItem, { ...tableContentItem });
            hideModal();
        }
        else if (requestViewAsAccess) {
            requestViewAsAccess(tableContentItem);
        }
        else if (updateLicenseImportShoppingCart) {
            updateLicenseImportShoppingCart(sourceItem, { ...tableContentItem });
            hideModal();
        }
        else if (componentInstance == SEARCH_VIEW_WORK_CLAIMS && addWorkToClaimRequest) {
            addWorkToClaimRequest({ ...tableContentItem });
            hideModal();
        }
        else if (componentInstance === SEARCH_VIEW_SUBJECTS) {
            sourceItem.subject.value = tableContentItem.code;
            updateSubjects({ ...sourceItem })
            hideModal();
        }
        else if (updateManualJobParams) {
            if (componentInstance === 'job_ip') {
                if (manualJobParameters === '') {
                    updateManualJobParams({
                        jobType: 'BEXP',
                        jobParameters: '{"ipNameNumber":"' + tableContentItem.ipiNumber + '","isbnPrefix":"","formatExport":"","format":""}'
                    });
                } else {
                    let manualJob = JSON.parse(manualJobParameters.jobParameters);
                    manualJob.ipNameNumber = tableContentItem.ipiNumber;
                    updateManualJobParams({
                        jobType: manualJobParameters.jobType,
                        jobParameters: JSON.stringify(manualJob)
                    });
                }
            }
            else if (componentInstance === 'cmuJob_ip') {
               updateCMUContributors(tableContentItem, modalIndex);
               hideModal();
            }
            hideModal();
        }
        else if (componentInstance === SEARCH_VIEW_LICENSE_USER) {
            updateLicenceUserValues({
                user: tableContentItem.email,
                crmUsers: licenseUserSearchResults
            });

            hideModal();
        }
        else if (addSetListToLivePerformance) {
            addSetListToLivePerformance(tableContentItem);
            hideModal()
        }
        else if (addWorkToSetList) {
            addWorkToSetList(tableContentItem);
            hideModal()
        }
        else if (updateAgreementCarveOutProduct) {
            getProductDetails('', tableContentItem.productCoreID, true)
            updateAgreementCarveOutProduct(sourceItem.agreementProductWorkID, { ...tableContentItem });
            hideModal();
        }
        else if (addMatchProductToUsage) {
            addMatchProductToUsage({ ...tableContentItem });
            hideModal();
        }
       
        else {
            updateAgreementWork(tableContentItem);
        }
    };

    onClickOpen = (tableContentItem: any, merged: boolean) => {
        const { openHistoryVersion, componentInstance, ctrlPressed } = this.props;
        switch (componentInstance) {
            case VERSION_HISTORY_VIEW:
                if (tableContentItem.agreementID !== undefined) {
                    openHistoryVersion(tableContentItem.agreementID, tableContentItem.versionNumber, merged, ctrlPressed);
                } else {
                    const opensIntrayArchive =
                        merged && tableContentItem.actionType !== MERGED_FROM_REPERTOIRE_WORK;

                    const entityId = opensIntrayArchive
                        ? tableContentItem.intrayWorkID
                        : tableContentItem.workID;
                    openHistoryVersion(entityId, tableContentItem.versionNumber, opensIntrayArchive, ctrlPressed);
                }
                break;
            case DISTRIBUTION_VERSION_HISTORY_VIEW:
                openHistoryVersion(tableContentItem.distributionID, tableContentItem.versionNumber, merged, ctrlPressed);
                break;
            default:
                break;
        }
    }

    renderTotalWorkflows = () => {
        const { componentInstance, totalWorkflows } = this.props;
        if (componentInstance == ASSING_WORKFLOW_VIEW) {
            return (
                <div><p>Workflows to assign: {totalWorkflows}</p></div>
            );
        }
        return null;
    }

    renderExpandAll = () => {
        const { expandAll, expandAllResults, expandResult } = this.props;
        return (expandResult ?
            <div className='arrowIconExpandDiv'>
                <div className={expandAll ? "arrowIconExpandAllExpanded" : "arrowIconExpandAll"}>
                    <ChevronDoubleLeft16Regular className="icon" aria-hidden="true" id="expandResultsButton" onClick={() => expandAllResults()} title={expandAll ? "Collapse Results" : "Expand Results"} />
                </div>
                {expandAll ? <div className='arrowIconExpandText'> Collapse Results</div> : <div className='arrowIconExpandText'> Expand Results</div>}
            </div> : <div></div>
        );
    }

    renderPaginationView(): JSX.Element {
        const { repertoireSection, searchResultsTableData } = this.props;
        const { tableContents, resultsPerPage, currentPage } = this.state;
        const paginationData = searchResultsTableData.fields.filter(field => field.componentInstance === PAGINATION);

        return <PaginationView
            contentsLength={tableContents ? tableContents.length : 0}
            resultsPerPage={resultsPerPage}
            currentPage={currentPage}
            updateContentsTable={this.updateContentsTable.bind(this)}
            repertoireSection={repertoireSection}
            paginationData={paginationData}
        />
    }

    updateContentsTable(indexOfFirstResult: number, indexOfLastResult: number, resultsPerPage: number, currentPage: number, repertoireSection: string): void {
        this.setState({ indexOfFirstResult, indexOfLastResult, resultsPerPage, currentPage });
        this.props.updatePagination(indexOfFirstResult, indexOfLastResult, resultsPerPage, currentPage, repertoireSection);
    }

    renderHeaderSections = () => {
        const { searchResultsTableData, componentInstance } = this.props;
        const { activeSortHeaderSection } = this.state;
        if (searchResultsTableData && searchResultsTableData.fields) {
            const filteredFields = searchResultsTableData.fields.filter(
                (field: IRepertoireField) =>
                    field.componentInstance === componentInstance && field.name !== "noSearchResultsMessage" && field.name !== ADD_TO_PACKAGE_ACTION && field.name !== ADD_ALL_TO_PACKAGE_PROMPT_STATE_KEY && field.name !== ADD_ALL_TO_PACKAGE_HEADER_STATE_KEY
            );
            const isAgreementPage = this.state.tableContents.some(item => item.agreementID !== undefined);
            const displayFields = isAgreementPage
                ? filteredFields.filter(x => x.name !== 'intrayWorkID')
                : filteredFields.filter(x => x.name !== 'intrayAgreementID');
           
                return displayFields.map((section: IRepertoireField, index: number) => (
                <td key={index} className="td">
                    <TableHeaderSection
                        section={section.data}
                        fieldName={section.name}
                        isSortingActive={section.name === activeSortHeaderSection}
                        ascending={this.ascending}
                        onClickHeaderSection={this.sortTableByColumn}
                        sortable
                    />
                </td>
                ));
        }
    };

    excludeObjectKeys = (key: string) => {
        const excludedKeys = ['compoundType', 'type', 'id1', 'id2', 'source', 'workContributorIDs', 'workID', 'status', 'productType', 'musicDuration'];

        if (excludedKeys.includes(key)) {
            return false;
        } else {
            return true;
        }
    }

    isNonEmptyValue = (value: any): boolean => {
        if (value === null || value === undefined) {
            return false;
        }
        if (Array.isArray(value)) {
            return value.length > 0;
        }
        if (typeof value === "string") {
            return value.trim().length > 0;
        }
        return true;
    }

    renderMultipleTitlesDiv = (array: string[]) => {
        return (
            <div className="multipleTitlesDiv">
                {array.map((item, index) => (
                    <div key={index}>
                        {item}
                        {index + 1 !== array.length ? <span>,</span> : null}
                    </div>
                ))}
            </div>
        );
    };

    getRowClassName = (tableContentItem: any) => {
        const isAgreementRow = tableContentItem.agreementID !== undefined;

        const isIntrayAgreementRow =
            isAgreementRow &&
            this.state.tableContents.some(r => r.intrayAgreementID === tableContentItem.agreementID);

        const isStandaloneIntrayWorkHistory =
            this.state.tableContents?.length > 0 &&
            this.state.tableContents.every(
                r => r?.isIntrayHistoryRow === true && r?.repertoireWorkID == null
            );

        if (!isStandaloneIntrayWorkHistory && (tableContentItem?.isIntrayHistoryRow === true || isIntrayAgreementRow)) {
            return 'trSelectable intrayRow';
        }

        return 'trSelectable';
    }

    isContributorNotSelectable = (tableContentItem: any): boolean => {
        return !!tableContentItem?.status && IPI_NON_SELECTABLE_STATUS_CODES.includes(tableContentItem.status);
    }

    renderSearchResults = () => {
        const { tableContents, indexOfFirstResult, indexOfLastResult, isFieldEnabled } = this.state;
        const { searchResultsTableData, componentInstance, expandedResults, expandResult, openInSplitScreen, expandAll, lookupValues } = this.props;
        const currentResults = tableContents.length === 1 ? tableContents :  tableContents.slice(
            indexOfFirstResult,
            indexOfLastResult
        );
        const workNameLookups = lookupValues ? getLookupValues(WORK_NAME_LOOKUP, lookupValues) : [];
        const resolveTitleTypeCode = (typeCode?: string) => {
            const typeId = Number(typeCode);
            const matchedLookup = workNameLookups.find((lookup) => lookup.typeID === typeId);
            if (matchedLookup?.code) {
                return matchedLookup.code;
            }
        };
        const formatWorkTitleWithTypeCode = (title: string, typeCode?: string) => {
            if (!title || !typeCode) {
                return title;
            }
            return `${title} (${typeCode})`;
        };
        let filteredFields = searchResultsTableData.fields.filter(
            (field: IRepertoireField) =>
                field.componentInstance === componentInstance && field.name !== "noSearchResultsMessage" && field.name !== ADD_TO_PACKAGE_ACTION && field.name !== ADD_ALL_TO_PACKAGE_PROMPT_STATE_KEY && field.name !== ADD_ALL_TO_PACKAGE_HEADER_STATE_KEY
        );
        return currentResults.map(
            (tableContentItem: any, index: number) => {
                const sections: JSX.Element[] = [];
                const isAgreementPage = tableContentItem.agreementID !== undefined;
                const displayFields = isAgreementPage
                    ? filteredFields.filter(x => x.name !== 'intrayWorkID')
                    : filteredFields.filter(x => x.name !== 'intrayAgreementID');

                const isIntrayAgreementRow = isAgreementPage && this.state.tableContents.some(r => r.intrayAgreementID === tableContentItem.agreementID);
                var openText = displayFields.find(x => x.fieldType == OPEN_ACTION);

                const isWorkVersionHistory = componentInstance === VERSION_HISTORY_VIEW;

                const isStandaloneIntrayWorkHistory =
                    isWorkVersionHistory &&
                    this.state.tableContents?.length > 0 &&
                    this.state.tableContents.every(
                        r => r?.isIntrayHistoryRow === true && r?.repertoireWorkID == null
                    );

                const isIntrayChildWorkHistoryRow =
                    isWorkVersionHistory &&
                    !isStandaloneIntrayWorkHistory &&
                    tableContentItem.isIntrayHistoryRow === true;
                
                    displayFields.map((field, x: number) => { 
                    if (field.fieldType === ADD_NEW_ACTION) {
                        sections.push(
                            <td key={`${index}.${x}`} className="td hideResponsiveLabel" title={field.data}>
                                <ActionButton
                                    buttonText={field.data}
                                    buttonAction={() => this.onClickAdd(tableContentItem)}
                                />
                            </td>
                        );
                    }
                    else if (field.fieldType === UPDATE_ACTION && componentInstance === SEARCH_VIEW_REQUEST_ACCESS) {
                        sections.push(
                            <td key={`${index}.${x}`} className="td hideResponsiveLabel" title={field.data}>
                                <div className="IconTextButton" data-toggle="modal" data-target="#settingsModal" onClick={() => this.onClickUpdate(tableContentItem)}>
                                    <PersonQuestionMark16Regular className="icon" aria-hidden="true" />
                                    {field.data}
                                </div>
                            </td>
                        );
                    }
                    else if (field.fieldType === UPDATE_ACTION && componentInstance === ASSING_WORKFLOW_VIEW) {
                        sections.push(
                            <td key={`${index}.${x}`} className="td hideResponsiveLabel" title={field.data}>
                                <ActionButton
                                    buttonText={"Assign"}
                                    buttonAction={() => this.onClickUpdate(tableContentItem, index)}
                                />
                            </td>
                        );
                    }
                    else if (field.fieldType === UPDATE_ACTION) {
                        const isNotSelectable = this.isContributorNotSelectable(tableContentItem);
                        sections.push(
                            <td key={`${index}.${x}`} className="td hideResponsiveLabel" title={isNotSelectable ? "Cross referenced or deleted IPs cannot be selected" : field.data}>
                                <ActionButton
                                    buttonText={field.data}
                                    buttonAction={() => this.onClickUpdate(tableContentItem,index)}
                                    disabled={isNotSelectable}
                                />
                            </td>
                        );
                    }
                    else if (field.fieldType === OPEN_ACTION) {
                        sections.push(
                            <td key={`${index}.${x}`} className="td hideResponsiveLabel" title={field.data}>
                                {!isIntrayChildWorkHistoryRow && !isIntrayAgreementRow && (
                                    <ActionButton
                                        buttonText={field.data}
                                        buttonAction={() => this.onClickOpen(tableContentItem, !tableContentItem["repertoireWorkID"] ? false : true)}
                                    />
                                )}
                            </td>
                        );
                    }
                    else if (field.name === "dateModified") {
                        // works, agreements, distributions, pools, adjustments - dateModified is returned "DD/MM/YYYY HH:mm:ss"
                        const isDateTimeSplitFormat = !!(
                            tableContentItem.workID ||
                            tableContentItem.intrayWorkID ||
                            tableContentItem.repertoireWorkID ||
                            tableContentItem.intrayAgreementID ||
                            tableContentItem.agreementID ||
                            tableContentItem.distributionID ||
                            tableContentItem.poolID ||
                            tableContentItem.adjustmentID
                        );

                        if (isDateTimeSplitFormat){
                            sections.push(
                                <td key={`${index}.${x}`} className="td" title={field.data}>
                                    <div className="tableSection">
                                        <DateDisplay value={tableContentItem[field.name]} showTime={true} isDateTimeSeperatedBySpaceFromVersionHistory={true} />
                                    </div>
                                </td>
                            );
                        }
                        else{
                            sections.push(
                                <td key={`${index}.${x}`} className="td" title={field.data}>
                                    <div className="tableSection">
                                        <DateDisplay value={tableContentItem[field.name]} showTime={true}/>
                                    </div>
                                </td>
                            );
                        }
                    }
                    else if (field.name === "intrayWorkID") {
                        let button;
                        const showMergedWorkCellValue = isIntrayChildWorkHistoryRow;

                        if (showMergedWorkCellValue && tableContentItem["intrayWorkID"] != null) {
                            button = <button className="button btn-defaultPrimary"
                                onClick={() => this.onClickOpen(tableContentItem, true)}>
                                {openText.data}
                            </button>
                        }
                        sections.push(
                            <td key={`${index}.${x}`} className="td" title={field.data} style={{ minWidth: '200px' }}>
                                <div className="tableSection">
                                    <label>{
                                        showMergedWorkCellValue
                                            ? [
                                                "contributors",
                                                "administeredBy",
                                                "works",
                                                "agreement_ip",
                                                "agreementSource_ip",
                                                "registeredWorks",
                                                "draftWorks",
                                                VERSION_HISTORY_VIEW,
                                                DISTRIBUTION_VERSION_HISTORY_VIEW
                                            ].includes(componentInstance)
                                                ? tableContentItem[field.name]
                                                : tableContentItem[field.name].value
                                            : EMPTY_STRING_VALUE
                                    }</label>
                                    {button}
                                </div>
                            </td>
                        );
                    }
                    else if (field.name === "intrayAgreementID") {
                        let button;
                        if (isIntrayAgreementRow) {
                            button = <button className="button btn-defaultPrimary"
                                onClick={() => this.onClickOpen(tableContentItem, true)}>
                                {openText.data}
                            </button>
                        }
                        sections.push(
                            <td key={`${index}.${x}`} className="td" title={field.data} style={{ minWidth: '200px' }}>
                                <div className="tableSection">
                                    <label>{isIntrayAgreementRow ? tableContentItem['agreementID'] : null}</label>
                                    {button}
                                </div>
                            </td>
                        );
                    }
                    else if (field.name === "numberOfWorkflows") {
                        let isDisabled = !isFieldEnabled[tableContentItem.userName.value];
                        sections.push(
                            <td key={`${index}.${x}`} className="td" title={field.data}>
                                <div className="tableSection">
                                    <InputNumber
                                        value={tableContentItem[field.name].value}
                                        readOnly={isDisabled}
                                        disabled={isDisabled} type={'number'}
                                        size='large'
                                        onChange={(newValue) => this.changeData(tableContentItem.userName.value, field.name, newValue)}
                                        onClick = { e => e.currentTarget.select() } />
                                </div>
                            </td>
                        );
                    }
                    else if (field.name === "assigned") {
                        sections.push(
                            <td key={`${index}.${x}`} className="td" title={field.data}>
                                <div className="tableSection">
                                    <SizedCheckboxDataInput
                                        label={null}
                                        fieldName={null}
                                        value={isFieldEnabled[tableContentItem.userName.value]}
                                        readonly={true}
                                        changeData={(value: string | boolean, fieldName: string): void => {}}/>
                                </div> 
                            </td>
                        );
                    }
                    else {
                        let item;
                        if (componentInstance === SEARCH_VIEW_WORKS || componentInstance === 'draftAgreementsApplicableWorks' || componentInstance === SEARCH_VIEW_PRODUCTS || componentInstance === SET_LISTS_WORK_SEARCHVIEW_STATE_KEY ||componentInstance === DRAFT_AGREEMENTS_APPLICABLE_WORKS_STATE_KEY) {
                            if (!this.excludeObjectKeys(field.name)) {
                                item = tableContentItem[field.name];
                            }
                            else {
                                item = tableContentItem[field.name] ? tableContentItem[field.name][0] : '-';
                            }

                            if (item)
                                item = item.toString();
                        }
                        const isTitleField = field.name === 'title';
                        const isRepertoireWork = tableContentItem?.dataSource === REPERTOIRE;
                        const titleTypeCodes = Array.isArray(tableContentItem?.titleTypeCodes) ? tableContentItem.titleTypeCodes : [];
                        const rawTitleValues = Array.isArray(tableContentItem?.[field.name]) ? tableContentItem[field.name] : [];
                        const formattedTitleValues = isTitleField && isRepertoireWork && titleTypeCodes.length > 0
                                ? rawTitleValues.map((title, titleIndex) =>
                                        formatWorkTitleWithTypeCode(title, resolveTitleTypeCode(titleTypeCodes[titleIndex]))
                                    )
                                : undefined;
                        const titleValues = formattedTitleValues ?? rawTitleValues;
                        const hasMultipleTitleValues = Array.isArray(titleValues) && titleValues.length > 1;
                        const displayItem = isTitleField ? (formattedTitleValues ? formattedTitleValues[0] : item) : item;
                        const valuesToRender = isTitleField ? titleValues : tableContentItem[field.name];
                        const hasMultipleValues = this.excludeObjectKeys(field.name) && (isTitleField ? hasMultipleTitleValues : tableContentItem[field.name]?.length > 1);
                        sections.push(
                            (componentInstance === SEARCH_VIEW_WORKS || componentInstance === 'draftAgreementsApplicableWorks' ||componentInstance === SEARCH_VIEW_PRODUCTS || componentInstance === SET_LISTS_WORK_SEARCHVIEW_STATE_KEY) ?
                                <td key={`${index}.${x}`} className="td" title={this.isNonEmptyValue(tableContentItem[field.name]) ? field.data : ""}>
                                    <div className="arrowIconDiv">
                                        {field.name === 'title' && componentInstance === SEARCH_VIEW_PRODUCTS ? (
                                            <img
                                                src={RIGHT_ARROW_SVG}
                                                title="Expand title"
                                                alt="Right Arrow icon"
                                                className={
                                                    expandedResults?.includes(tableContentItem.productCoreID)
                                                        ? 'arrowIconExpanded'
                                                        : 'arrowIcon'
                                                }
                                                onClick={() => expandResult(tableContentItem.productCoreID)}
                                            />
                                        ) : (field.name === 'title' || field.name === 'type') ? (
                                            <img
                                                src={RIGHT_ARROW_SVG}
                                                title="Expand title"
                                                alt="Right Arrow icon"
                                                className={
                                                    expandedResults?.includes(tableContentItem.workID)
                                                        ? 'arrowIconExpanded'
                                                        : 'arrowIcon'
                                                }
                                                onClick={() =>
                                                    componentInstance !== 'draftAgreementsApplicableWorks'
                                                        ? expandResult(tableContentItem.workID)
                                                        : undefined
                                                }
                                            />
                                        ) : null}
                                          {(expandedResults && expandedResults.includes(tableContentItem.workID)) && hasMultipleValues ? (
                                          field.name === 'title' ? <a                              
                                           onClick={(event) => {
                                              event.preventDefault(); 
                                               openInSplitScreen(tableContentItem, event);
                                           }}
                                       >{ this.renderMultipleTitlesDiv(valuesToRender)}</a> : this.renderMultipleTitlesDiv(valuesToRender)
                                        ) : (
                                            field.name === 'title' && openInSplitScreen ? <a                              
                                            onClick={(event) => {
                                               event.preventDefault(); 
                                                openInSplitScreen(tableContentItem, event);
                                            }}
                                        >
                                            {(expandedResults && expandedResults.includes(tableContentItem.workID)) && hasMultipleValues ? (
                                                this.renderMultipleTitlesDiv(valuesToRender)
                                            ) : (
                                                <div className="workTitle">
                                                    {displayItem ? displayItem.replace(/,\s*$/, "") : displayItem}
                                                </div>
                                            )}                           
                                        </a> : (expandedResults && expandedResults.includes(tableContentItem.workID)) && hasMultipleValues ? (
                                            this.renderMultipleTitlesDiv(valuesToRender)
                                            ) : (componentInstance === SEARCH_VIEW_PRODUCTS && (!expandedResults?.includes(tableContentItem.productCoreID) && !expandAll)) ? (
                                              <div className="workTitle"
                                                style={{
                                                    whiteSpace: 'nowrap',
                                                    overflow: 'hidden',
                                                    textOverflow: 'ellipsis',
                                                    maxWidth: '150px'
                                                }}>
                                                    {displayItem ? displayItem.replace(/\n/g, ' ').replace(/,\s*$/, "") : displayItem}

                                              </div>
                                        ) : (
                                            <div className="workTitle">
                                                {displayItem ? displayItem.replace(/,\s*$/, "") : displayItem}
                                            </div>
                                        )  
                                        )}
                                    </div>
                                </td>
                                :
                                <td key={`${index}.${x}`} className={`td ${field.name === 'versionNumber' ? 'paddedVersion' : ''}`} title={field.data} >
                                    <div className="tableSection">
                                        <label>{
                                            field.name === IPI_NUMBER_STATE_KEY ? RepertoireHelper.zeroPaddedIPINameNumber(tableContentItem[field.name]) :
                                                [
                                                    "contributors",
                                                    "administeredBy",
                                                    "works",
                                                    "agreement_ip",
                                                    "agreementSource_ip",
                                                    "artists",
                                                    "job_ip",
                                                    "cmuJob_ip",
                                                    "license_user",
                                                    VERSION_HISTORY_VIEW,
                                                    DISTRIBUTION_VERSION_HISTORY_VIEW,
                                                    "requestAccess",
                                                    SEARCH_VIEW_WORK_LICENSES,
                                                    SEARCH_VIEW_LICENSES_FILEIMPORT,
                                                    "registeredWorks",
                                                    "draftWorks",
                                                    SET_LIST_MODAL_SEARCH_VIEW,
                                                    "productWorkSearch", 
                                                    SEARCH_VIEW_WORK_CLAIMS,
                                                    SEARCH_VIEW_CLAIMS,
                                                    SEARCH_VIEW_SUBJECTS,
                                                    SEARCH_VIEW_IPS,
                                                    SEARCH_VIEW_VENUES,
                                                    LICENSE_VENUES_KEY
                                                ].includes(componentInstance) ? tableContentItem[field.name] : tableContentItem[field.name]?.value}</label>

                                    </div>
                                </td>)
                    }
                });

                return (
                    <tr
                        key={index}
                        className={this.getRowClassName(tableContentItem)}
                        onClick={() => null}
                    >
                        {sections}
                    </tr>
                );
            }
        );
    };
    
    render() {
        return (
            <div className="selectionTable">
                {this.renderExpandAll()}
                {this.renderPaginationView()}
                {this.renderTotalWorkflows()}
                <div className="tableContainer">
                    <table className="table">
                        <thead className="thead">
                            <tr className="tr">{this.renderHeaderSections()}</tr>
                        </thead>
                        <tbody className="tbody">{this.renderSearchResults()}</tbody>
                    </table>
                </div>
                {this.renderPaginationView()}
            </div>
        );
    }
}

